<template>
  <div>
    <div class="mb-12">
      <v-row>
        <v-col>
          <v-card-title
            class="display-2 letter-spacing-compact font-weight-bold mb-12 align-center px-5"
          >
            {{ $route.params.id ? 'Edit' : 'New' }} Species
          </v-card-title>
        </v-col>
      </v-row>

      <validation-observer ref="validator">
        <v-form @submit.prevent="submit()">
          <v-container fluid class="mx-1060">
            <v-row>
              <v-col
                cols="12"
                class="pr-md-7"
                :lg="rightDrawer.opened ? 12 : 6"
                :md="rightDrawer.opened ? 12 : 12"
              >
                <ValidationProvider
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    class=""
                    name="name"
                    :error-messages="errors"
                    v-model="request.name"
                    label="Species Name"
                    required
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                cols="12"
                class="pr-md-7"
                :lg="rightDrawer.opened ? 12 : 6"
              >
                <ValidationProvider
                  name="latin_name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    class=""
                    name="latin_name"
                    :error-messages="errors"
                    v-model="request.latin_name"
                    label="Latin Name"
                    required
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="pr-md-7"
                :lg="rightDrawer.opened ? 12 : 6"
              >
                <ValidationProvider
                  name="family"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    :menu-props="{ contentClass: 'notranslate' }"
                    search-input.sync="filterFamily"
                    v-model="request.family_id"
                    :items="families"
                    :loading="familyModel.fetching"
                    hide-selected
                    item-text="name"
                    item-value="id"
                    label="Select Family"
                    placeholder="Start typing to Search"
                    :error-messages="errors"
                    class="notranslate"
                    required
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="pr-md-7"
                :lg="rightDrawer.opened ? 12 : 6"
              >
                <ValidationProvider
                  name="cost"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    class=""
                    name="cost"
                    :error-messages="errors"
                    v-model="request.cost"
                    label="Cost"
                    required
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="pr-md-7"
                :lg="rightDrawer.opened ? 12 : 6"
              >
                <DropZone
                  :required="true"
                  ref="media"
                  :remote-files="species.media.photos"
                  :subjectId="species.id"
                  subjectType="species"
                  category="photos"
                  name="species_photo"
                  :allowMultiple="false"
                  class=""
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </validation-observer>

      <v-card-actions class="px-5">
        <v-btn
          large
          color="white"
          class="elevation-1 font-weight-bold px-8 mr-10"
          min-width="275px"
          @click="goToList()"
        >
          Cancel
        </v-btn>
        <v-btn
          large
          color="primary"
          class="elevation-1 font-weight-bold px-8"
          min-width="275px"
          @click.prevent="submit()"
          :disabled="request.submitting"
        >
          Done
        </v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import Request from '@request/SpeciesRequest';
import Model from '@models/Species';
import FamilyModel from '@models/SpeciesFamily';

export default {
  name: 'Create',
  metaInfo: {
    titleTemplate: '%s - Manage Species',
  },
  components: {
    DropZone: () => import('@components/utilities/DropZone'),
  },
  beforeRouteEnter(to, from, next) {
    next(async function(vm) {
      vm.fetchFamilies();
    });
  },
  data() {
    return {
      families: [],
      request: new Request(this.$refs),
      species: {
        media: {
          image: [],
        },
      },
      model: new Model({
        relations: ['family', 'media'],
      }),
      familyModel: new FamilyModel({
        page: 1,
        limit: 5,
      }),
      filterFamily: '',
    };
  },
  watch: {
    filterFamily() {
      this.fetchFamilies();
    },
  },
  methods: {
    async fetchFamilies() {
      if (this.filterFamily)
        this.familyModel.setFilters({
          name: this.filterFamily,
        });
      else this.familyModel.removeFilter('name');
      let response = await this.familyModel.get();
      if (response) {
        this.families = response.data;
        let family = this.species.family;
        if (!this.families.find((data) => data.id === family.id)) {
          this.families = this.families.concat([family]);
        }
      }
    },
    async submit() {
      if (await this.$refs.validator.validate()) {
        let response = await this.request.submit();
        if (response) {
          await this.$refs.media.upload(this.species.id || response.data.id);
          if (!this.request.id) {
            this.goToList();
          }
        }
      }
    },
    goToList() {
      if (this.$route.from && this.$route.from.name === 'species') {
        this.$route.back();
        return;
      }
      this.$router.push({
        name: 'species',
      });
    },
  },
  async mounted() {
    if (this.$route.params.id) {
      let id = this.$route.params.id;
      let response = await this.model.findById(id);
      if (response) {
        let species = response.data;
        Object.assign(this.species, species);
        this.request.reinit(species);
      }
    }
  },
};
</script>

<style scoped></style>
